import React from 'react';
import styled from 'styled-components';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Layout } from '../../../components-core/packages/components-core/dist/layout';

//STYLE
import { 
    Text, 
    TextAppearance, 
    TextColor
} from '../../../components-core/packages/components-core/dist/text';

//ICONS
import { Checkmark } from '../../../components-core/packages/icons-core/dist/Checkmark';


const Table = styled.table`
    width: 100%;
    border: 1px solid #dfe4e8;
    table-layout: fixed;
    border-collapse: collapse;
`;


const Row = styled.tr`
    border: none;
    width: 100%;
    &:nth-child(odd) {
        background-color: #dfe4e8;
    }
`;

const Cell = styled.td`
    border-left: 1px solid #dfe4e8;
    border-right: 1px solid #dfe4e8;

    @media (max-width: 768px) {
        &:nth-child(4), &:nth-child(3) {
            display: none;
        }
    }
`;


class ModelComparisonTable extends React.Component {

    renderRows() {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;

        return dummyData.map((data, index) =>
            [
                <Row>{renderCell(data.title, true, false)} </Row>,
                <Row>
                    {data.cars.map((car, index) => renderCell(car, false, isMobile))}
                </Row>
            ]
        )
    }

    render() {
        return (
            <Table>
                {this.renderRows()}
            </Table>
        )
    }
}

const renderCell = (data, isSingular, isMobile) => (
    <Cell colSpan={isSingular ? 4 : isMobile ? 2 : 1}>
        <Container 
            horizontalAlign={isSingular ? ContainerHorizontalAlignment.flexStart : ContainerHorizontalAlignment.center} 
            padding={{ 
                top: ContainerPadding.static100, 
                bottom: ContainerPadding.static100,
                left: isSingular && ContainerPadding.dynamic0300
            }} 
        >
            <Text appearance={TextAppearance.copy0150}>{
                isSingular ? data : data.status === 2 ? 'Opsiyonel' : data.status === 1 ? <Checkmark variant={'small'}/> : '-'}
            </Text>
        </Container>
    </Cell>
)

const dummyData = [
    {
        title: 'Hava yastığı',
        cars: [
            {'carName': 'Caddy Panel Van', 'status': 1},
            {'carName': 'Caddy Panel', status: 2},
            {'carName': 'Caddy Trendline', status: 0},
            {'carName': 'Caddy', status: 1}
        ]
    },
    {
        title: 'Baba yastığı',
        cars: [
            {'carName': 'Caddy Panel Van', 'status': 1},
            {'carName': 'Caddy Panel', status: 0},
            {'carName': 'Caddy Trendline', status: 0},
            {'carName': 'Caddy', status: 1}
        ]
    }
]

export default ModelComparisonTable;



